export const ACTION_BTN_POPOVER_EVENT_EMITTER = 'toggle-action-popover'
export const ADD_PROVIDER_DIALOG_EVENT_EMITTER = 'add-watch-list-provider'
export const SWITCH_VIEW_EVENT_EMITTER = 'switch-view-from-quick-link'
export const WATCH_LIST_POPOVER_EVENT_EMITTER = 'toggle-watch-list-popover'
